import { Theme } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const dividerStyles = (_theme: Theme) => ({
  MuiDivider: {
    styleOverrides: {
      root: {
        width: '100%',
      },
    },
  },
});
